import { createSelector } from '@reduxjs/toolkit';

import { Group } from '@/types/authent/groups.types';
import { User } from '@/types/authent/login.types';

import { RootState } from '../store';
import { AuthentState } from './authent.reducer';

export function selectAuthentState(state: RootState): AuthentState {
  return state.authent;
}

export const selectActiveUser = createSelector(selectAuthentState, (state: AuthentState): User => state.activeUser);

export const selectActiveGroup = createSelector(selectActiveUser, (state: User): Group | null => state.activeGroup);

export const selectActiveOrganization = createSelector(
  selectActiveGroup,
  (group: Group | null): string | null => group?.organization ?? null,
);
